import { render, staticRenderFns } from "./PermissionGroupsCreateGroup.vue?vue&type=template&id=3dcf9c99"
import script from "./PermissionGroupsCreateGroup.vue?vue&type=script&lang=js"
export * from "./PermissionGroupsCreateGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports